__turbopack_context__.v({
  "colSubtitle": "TableItem-module-scss-module__cAJgfa__colSubtitle",
  "colTitle": "TableItem-module-scss-module__cAJgfa__colTitle",
  "container": "TableItem-module-scss-module__cAJgfa__container",
  "header": "TableItem-module-scss-module__cAJgfa__header",
  "icon": "TableItem-module-scss-module__cAJgfa__icon",
  "item": "TableItem-module-scss-module__cAJgfa__item",
  "list": "TableItem-module-scss-module__cAJgfa__list",
  "rowSubtitle": "TableItem-module-scss-module__cAJgfa__rowSubtitle",
  "rowTitle": "TableItem-module-scss-module__cAJgfa__rowTitle",
  "textWrapper": "TableItem-module-scss-module__cAJgfa__textWrapper",
  "titleNotation": "TableItem-module-scss-module__cAJgfa__titleNotation",
  "top": "TableItem-module-scss-module__cAJgfa__top",
});
